module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Phonological Error Patterns from a"), _c('br'), _vm._v("Clinical Perspective")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-1-difference-between-phonology-and-articulation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Difference Between Phonology and Articulation")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#chapter-outlines",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Outlines")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#dual-nature-of-speech",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dual Nature of Speech:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#difference-between-phonology-and-articulation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Difference between Phonology and Articulation:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0003#how-to-differentiate-phonological-disorders-from-articulation-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Differentiate Phonological Disorders from Articulation Disorders?")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0010#chapter-summary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0004#references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-2-speech-development-and-theories-of-acquisition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Speech Development and Theories of Acquisition")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#chapter-outlines-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Outlines")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#stages-of-speech-development",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stages of Speech Development")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#prerequisites-for-normal-phonemic-and-phonetic-development",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prerequisites for Normal Phonemic and Phonetic Development:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0008#phonological-acquisition-theories-gordon-brannan-and-weiss-2007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phonological Acquisition Theories (Gordon-Brannan and Weiss, 2007):")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0009#chapter-summary-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0005#references-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-3-overview-of-phonological-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Overview of Phonological Error Patterns")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#chapter-outlines-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Outlines")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#classification-of-phonological-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classification of Phonological Error Patterns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#word-and-syllable-level-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1-Word and Syllable-Level Error Patterns:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#assimilation-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2-Assimilation Error Patterns:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#feature-contrast-or-substitution-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3-Feature Contrast or Substitution Error Patterns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#others",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4-Others:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#age-of-suppression-of-phonological-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Age of Suppression of Phonological Error Patterns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#methods-of-assessment-of-phonological-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Methods of Assessment of Phonological Error Patterns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#age-appropriate-speech-sampling-tasks-stein-rubin-and-fabus-2011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Age-Appropriate Speech Sampling Tasks (Stein-Rubin and Fabus, 2011)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#selection-criteria-for-target-words-used-in-the-assessment-of-phonological-error-patterns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selection Criteria for Target Words Used in the Assessment of Phonological Error Patterns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#phonetic-transcription",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phonetic Transcription")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0011#analysis-methods",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Analysis Methods")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0012#chapter-summary-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0006#references-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-4-speech-sound-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Speech Sound Disorders")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#chapter-outlines-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Outlines")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#abc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Definition")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#prevalence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prevalence")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#speech-processing-chain-and-its-breakdowns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speech-Processing Chain and its Breakdowns")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#phonological-characteristics-of-speech-sound-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phonological Characteristics of Speech Sound Disorders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#genetic-theory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Genetic Theory")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#causes-of-articulation-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Causes of Articulation Disorders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#causes-of-phonological-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Causes of Phonological Disorders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#diagnostic-criteria-of-speech-sound-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diagnostic Criteria of Speech Sound Disorders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#subtypes-of-speech-sound-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subtypes of Speech Sound Disorders:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#assessment-of-speech-sound-disorders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assessment of Speech Sound Disorders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#case-history",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Case History")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#vocal-tract-examination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Vocal Tract Examination")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#hearing-screening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Hearing Screening")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#speech-sound-assessment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Speech Sound Assessment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#the-phonology-assessment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phonology Assessment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#severity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Severity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#intelligibility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intelligibility")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#inconsistency-assessment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inconsistency Assessment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#spoken-language-testing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Spoken Language Testing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#phonological-processing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Phonological Processing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#literacy-assessment-reading-and-writing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Literacy Assessment [Reading and Writing]")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#special-considerations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Considerations")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0013#prognosis-of-ssd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prognosis of SSD")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0014#chapter-summary-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0007#references-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0